import {
  IPlatformAddress,
  IPlatformAddressData
} from './index'

export class PlatformAddress implements IPlatformAddress {
  readonly id?: number
  street: string
  locations: string[]
  zip: string

  constructor(data?: IPlatformAddressData) {
    this.id = data?.id
    this.street = data?.street || 'Franciszka Klimczaka 1'
    this.locations = data?.locations || [
      'Royal Wilanów',
      'Bee Creative'
    ]
    this.zip = data?.zip || '02-797'
  }

  get key(): string {
    let id = this.id;
    return (id ? (id + '-') : '') + this.street;
  }
}
